import type { Client, DateISO } from "~/types";
import { isoToTime } from "./date";
import { mbToBytes } from "./general";
import { ALLOWED_FILE_EXTENSIONS, getFileExtension, MAX_FILE_SIZE } from "./media";

export function required(v: string | number) {
  return !!v || v === 0;
}
export function atLeastOne(arr: any[]) {
  return arr.length > 0;
}
export function emailRule(v: string) {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(v);
}
export function fileSizeRule(v: File, max = MAX_FILE_SIZE) {
  return !v || v.size < mbToBytes(max);
}
export function imageTypeRule(f: File | null) {
  if (!f) return false;
  const ext = getFileExtension(f);
  return ALLOWED_FILE_EXTENSIONS.includes(ext);
}
export function minDateRule(min: Date, v: DateISO) {
  return isoToTime(v) >= min.getTime();
}
export function maxDateRule(max: Date, v: DateISO) {
  return isoToTime(v) <= max.getTime();
}
export function isClientValid(client: Client) {
  return !!(client.name && emailRule(client.email));
}